module.exports = __webpack_public_path__ + "img/sutherapy_01.1dc2593b.jpg";